// extracted by css-extract-rspack-plugin
export default {"flags-wrapper":"FaIESV","flagsWrapper":"FaIESV","tooltip-icon":"FT_zyr","tooltipIcon":"FT_zyr","tooltip-link":"o_W4hC","tooltipLink":"o_W4hC"};